var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useEntityLayout } from '../hooks/use-entity-layout';
import { EntityProvider } from '../context/entity-context';
import { PageEntityProvider } from '../context/page-entity-context';
import { useProfileQuery } from '../hooks/use-profile-query';
import { ManagementProvider } from '../context/management-context';
import { GlowContainer } from '../elements/glow-loader';
var cls = classNames('entity-route-profile');
export var AppRouteProfileDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme.COLOR('app-chrome'))
});
var GlowContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed;\n    z-index: 100;\n    bottom: 10px;\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n  "], ["\n    position: fixed;\n    z-index: 100;\n    bottom: 10px;\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'AppRouteProfile',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  GlowContainer: styled(GlowContainer)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), GlowContainerStyles)
};
export var AppRouteProfile = function (props) {
  var componentProps = useComponentProps(My.NAME, AppRouteProfileDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children;
  // read the full hash, and assume this is a slug. This can then be used to dynamically query the entity type
  var Layout = useEntityLayout('Person');
  var _a = useProfileQuery(),
    entity = _a.entity,
    query = _a.query,
    refetch = _a.refetch,
    loading = _a.loading;
  return React.createElement(ManagementProvider, {
    value: {
      isCurrentProfile: true,
      isOwn: true,
      canEdit: true,
      editControlsMode: 'always'
    }
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(EntityProvider, {
    value: entity
  }, React.createElement(PageEntityProvider, {
    value: entity
  }, React.createElement(Layout, {
    entity: entity,
    loading: loading
  })))));
};
AppRouteProfile.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;